import React from "react";
import { Trans } from "react-i18next";
import i18next from "i18next";

import {
  Button,
  Callout,
  Classes,
  Dialog,
  HTMLTable,
  Icon,
  Spinner,
  Tag,
} from "@blueprintjs/core";

import {
  authenticatedGetFetch,
  authenticatedPostFetch,
} from "../../../utils/AuthenticatedFetch";
import {
  mefDate,
  mefMontant,
  mefMontantStr,
  mefPlate,
} from "../../../utils/mef";
import PlateImage from "../ALPR/PlateImage";
import { deviceLookup } from "../../Structure/EquipmentSelector";
import { parkLookup } from "../../Structure/ParkSelector";

export function BookingStateTag(props) {
  switch (props.state) {
    case "A":
    case "U":
      return (
        <Tag intent="primary">
          <Trans>{"booking_status_" + props.state}</Trans>
        </Tag>
      );

    case "P":
    case "Q":
      return (
        <Tag intent="success">
          <Trans>{"booking_status_" + props.state}</Trans>
        </Tag>
      );

    case "C":
    case "B":
      return (
        <Tag intent="danger">
          <Trans>{"booking_status_" + props.state}</Trans>
        </Tag>
      );

    case "P":
      return (
        <Tag intent="warning">
          <Trans>{"booking_status_" + props.state}</Trans>
        </Tag>
      );

    default:
      return props.state;
  }
}

export class BookingManagement extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    this.setState({ loading: true }, () =>
      authenticatedGetFetch(
        `/booking/${this.props.id}?srv=${this.props.server}`,
        (response) => this.setState({ ...response, loading: false }),
        null,
        null,
        () => this.setState({ loading: false })
      )
    );
  }

  render() {
    const events = [];
    if (this.state.events !== undefined) {
      for (const event of this.state.events) {
        events.push(
          <li key={event.DAYEVEN}>
            {new Date(event.DAYEVEN).toLocaleString(i18next.language)} :{" "}
            <b>
              {event.event !== undefined && event.event !== null && (
                <Tag intent={event.event.intent}>
                  <Trans>{"event" + event.event.id}</Trans>
                </Tag>
              )}
            </b>{" "}
            <Trans>on device</Trans>{" "}
            {this.props.deviceLookup[
              event.syncServerId + "_" + event.NUMEEQUI
            ] ? (
              this.props.deviceLookup[event.syncServerId + "_" + event.NUMEEQUI]
            ) : (
              <span>{event.NUMEEQUI} </span>
            )}{" "}
            {event.MONTSTAT !== undefined && event.MONTSTAT > 0 ? (
              <span>({mefMontantStr(event.MONTSTAT)})</span>
            ) : null}
          </li>
        );
      }
    }
    return (
      <Dialog
        title={
          <span>
            <Trans>userType10</Trans> <b>{this.props.id}</b>
          </span>
        }
        isOpen={this.props.id !== undefined}
        canEscapeKeyCancel={true}
        canOutsideClickCancel={true}
        intent="primary"
        icon="book"
        onClose={() => {
          if (this.props.onClose !== undefined) this.props.onClose();
        }}
        onCancel={() => {
          if (this.props.onClose !== undefined) this.props.onClose();
        }}
      >
        {this.state.loading ? (
          <Callout>
            <Spinner />
          </Callout>
        ) : this.state.start === undefined ? (
          <Callout
            intent="warning"
            title={
              <span>
                <Trans>userType10</Trans> <Trans>not found on the server</Trans>
              </span>
            }
          >
            <p>
              <Trans>can't retreive data</Trans>
            </p>
            <p>
              <Trans>
                the booking could be purged according to the server settings
              </Trans>
            </p>
            <div className="flexbox-center">
              <Icon icon="unknown-vehicle" size="100" />
            </div>
          </Callout>
        ) : (
          <div>
            <ul>
              <li>
                <Trans>parking state:</Trans>{" "}
                <BookingStateTag state={this.state.status} />
              </li>
              <li>
                <Trans>park:</Trans> {parkLookup()[this.state.parks]}
              </li>
              <li>
                <Trans>start date:</Trans> {mefDate(this.state.start)}
              </li>
              <li>
                <Trans>end date:</Trans> {mefDate(this.state.end)}
              </li>
              {this.state.pincode && (
                <li>
                  Code<Trans>:</Trans> {this.state.pincode}
                </li>
              )}
              {this.state.plate && (
                <li>
                  <Trans>plate:</Trans> {mefPlate(this.state.plate)}
                </li>
              )}

              {this.state.montant && this.state.montant !== 0 && (
                <li>
                  <Trans>paid amount</Trans>
                  <Trans>:</Trans>
                  {mefMontantStr(this.state.montant)}
                </li>
              )}
            </ul>

            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              {["P", "Q"].includes(this.state.status) && (
                <Button
                  icon={"follower"}
                  text={<Trans>set absent</Trans>}
                  onClick={() =>
                    authenticatedPostFetch(
                      "/booking/checkinout",
                      {
                        bookingId: this.props.id,
                        type: "forceExit",
                        srv: this.props.server,
                      },
                      () => {
                        this.setState({ loading: true }, () =>
                          authenticatedGetFetch(
                            `/booking/${this.props.id}?srv=${this.props.server}`,
                            (response) =>
                              this.setState({ ...response, loading: false }),
                            null,
                            null,
                            () => this.setState({ loading: false })
                          )
                        );
                      }
                    )
                  }
                />
              )}

              {["A", "U", "C"].includes(this.state.status) && (
                <Button
                  icon={"following"}
                  text={<Trans>set present</Trans>}
                  onClick={() =>
                    authenticatedPostFetch(
                      "/booking/checkinout",
                      {
                        bookingId: this.props.id,
                        type: "forceEntry",
                        srv: this.props.server,
                      },
                      () => {
                        this.setState({ loading: true }, () =>
                          authenticatedGetFetch(
                            "/booking/" +
                              this.props.id +
                              "?srv=" +
                              this.props.server,
                            (response) =>
                              this.setState({ ...response, loading: false }),
                            null,
                            null,
                            () => this.setState({ loading: false })
                          )
                        );
                      }
                    )
                  }
                />
              )}
            </div>
          </div>
        )}
        {/* booking events history */}
        {this.state.events && this.state.events.length > 0 && (
          <Callout title={<Trans>event history</Trans>} icon="history">
            <HTMLTable striped={true} compact={true}>
              <tbody>
                {this.state.events.map((event) => (
                  <tr key={event.ID}>
                    <td>
                      {new Date(event.DAYEVEN).toLocaleString(i18next.language)}
                    </td>
                    <td>
                      {event.event !== undefined && event.event !== null && (
                        <Tag intent={event.event.intent}>
                          <Trans>{"event" + event.event.id}</Trans>
                        </Tag>
                      )}
                      {event.IMMAT && (
                        <>
                          <br />
                          <PlateImage
                            key="imm"
                            park={event.NUMEPARC}
                            plate={event.IMMAT}
                            date={event.DAYEVEN}
                            device={event.NUMEEQUI}
                            server={event?.syncServerId}
                          />
                        </>
                      )}
                    </td>
                    <td>
                      <Tag>
                        {parkLookup()[
                          this.props.server + "_" + event.NUMEPARC
                        ] || parkLookup()[event.NUMEPARC]}
                      </Tag>
                      <br />
                      <Tag>
                        {deviceLookup()[
                          this.props.server + "_" + event.NUMEEQUI
                        ] || deviceLookup()[event.NUMEEQUI]}
                      </Tag>
                    </td>
                    <td>{event?.MONTSTAT > 0 && mefMontant(event.MONTSTAT)}</td>
                  </tr>
                ))}
              </tbody>
            </HTMLTable>
          </Callout>
        )}
      </Dialog>
    );
  }
}
